import React, { Component } from 'react';
import { Box } from '../../element';

class Header extends Component {
  render() {
    return (
      <Box direction="column">
        <Box id="header" className="hpe_slim_header" />
      </Box>
    );
  }
}

export default Header;
